import React from 'react';
import { TooltipProps } from 'antd';
import * as S from './Tooltip.styles';
import './styles.css';

export const Tooltip: React.FC<TooltipProps> = ({ children, ...props }) => {
  return <S.Tooltip {...props}>{children}</S.Tooltip>;
};
